import { action } from 'mobx';
import { DependencyList, useCallback } from "react";

export const useAction = function <T extends (...args: any[]) => any>(callback: T, deps: DependencyList = []): T {
    // eslint-disable-next-line
    return useCallback<T>(action<T>(callback), deps);
}
